import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';

import { setModalState, setCaptchaToken } from 'store/entities/app';
import useTotalPrice from 'hooks/useTotalPrice';
import { executeCaptcha } from 'utils/captcha';
import { trackFormOpen, trackConfiguratorComplete } from 'utils/tracking/helpers';
import useTrackingContext from 'hooks/useTrackingContext';

import Price from 'components/Price';
import Disclaimer from 'components/Price/Disclaimer';

const StickyAside = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [captchaLoading, setCaptchaLoading] = React.useState(false);

  const { builderData } = useSelector(state => state.data);
  const totalPrice = useTotalPrice();
  const trackingContext = useTrackingContext();

  const handlePdfClick = () => {
    setCaptchaLoading(true);
    trackConfiguratorComplete(totalPrice, trackingContext);
    executeCaptcha('save_pdf').then(token => {
      dispatch(setCaptchaToken(token));
      dispatch(setModalState({ modal: 'pdfModal', newState: true }));
      setCaptchaLoading(false);
    });
  };

  return (
    <aside className="c-aside">
      <div className="c-aside__head">
        <p className="c-aside__title">
          {t('your_configured_car', { model: builderData.model?.name })}
        </p>
        <h6 className="c-aside__price">
          <Price price={totalPrice} />
          <Disclaimer />
        </h6>
      </div>
      <p className="c-aside__btnline">
        <Button
          variant="primary"
          onClick={() => {
            trackFormOpen('offer');
            dispatch(setModalState({modal: 'offerModal', newState: true, type: 'offer'}));
          }}
        >
          {t('ask_offer_button')}
        </Button>
        <Button
          variant="light"
          onClick={() => {
            trackFormOpen('testdrive');
            dispatch(setModalState({modal: 'offerModal', newState: true, type: 'testdrive'}));
          }}
        >
          {t('book_test_button')}
        </Button>
        <Button
          variant="light"
          onClick={handlePdfClick}
          disabled={captchaLoading}
        >
          {captchaLoading ? t('loading', 'Loading...') : t('pdf_button')}
        </Button>
      </p>
    </aside>
  );
};

export default StickyAside;
